export default "__VITE_ASSET__D7LyjT16__"